import db from "./db.js";

// Key-Value-Storage-Klasse
class KeyValueStorage {
    constructor() {
        this.table = db.localStorage;
    }

    async set(key, value) {
        try {
            const existingEntry = await this.table.where({ key }).first();
            if (existingEntry) {
                // Update existing value
                await this.table.update(existingEntry.id, { value });
            } else {
                // Add new entry
                await this.table.add({ key, value });
            }
        } catch (error) {
            console.error('Error setting value in storage:', error);
        }
    }

    async get(key) {
        try {
            const entry = await this.table.where({ key }).first();
            return entry ? entry.value : null;
        } catch (error) {
            console.error('Error getting value from storage:', error);
            return null;
        }
    }

    async has(key) {
        try {
            const count = await this.table.where({ key }).count();
            return count > 0;
        } catch (error) {
            console.error('Error checking value in storage:', error);
            return false;
        }
    }
}

// Export der globalen Instanz des Key-Value-Storage
const storage = new KeyValueStorage();
export default storage;